import { slugify } from '@wwe-portal/web/utils/string';
import Link from 'next/link';
import { FC, ReactNode } from 'react';

export const PlayerLink: FC<{
  name?: string;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}> = ({ name, children, className, onClick }) => {
  if (!name) return <>{children}</>;
  return (
    <Link
      className={className}
      href={`/player/${slugify(name)}`}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};
